export default __webpack_public_path__ + "58160a9657827cc2903c8c0d0bcdb8bb.png";